import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

interface HeaderProps {
  isAuthenticated: boolean;
  onLogout: () => void;
  title: string;
  isAdmin: () => boolean;
  isSuperAdmin: () => boolean;
}

const Header: React.FC<HeaderProps> = ({ isAuthenticated, onLogout, title, isAdmin, isSuperAdmin }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const username = localStorage.getItem('email');

  useEffect(() => {
    console.log('isMenuOpen:', menuOpen);
  }, [menuOpen]);

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  return (
    <header className='campsite-manager'>
      <div className='main-logo'>
      <Link to="/"> 
          <img src={`${process.env.PUBLIC_URL}/images/RajamaaLogo.svg`} alt="Rajamaa in Lapland" />
        </Link>
      </div>
      <div className='main-header'>{title}</div>
      {isAuthenticated && (
        <>
          <div className='dropdown desktop-menu'>
            <button
              className='btn btn-secondary dropdown-toggle'
              type='button'
              id='dropdownMenuButton'
              data-bs-toggle='dropdown'
              aria-expanded='false'
            >
              {username}
            </button>
            <ul className='dropdown-menu' aria-labelledby='dropdownMenuButton'>
              <li>
                <Link className='dropdown-item' to="/manager">Dashboard</Link>
              </li>
              <li>
                <Link className='dropdown-item' to="/newPackageManager">Manage Packages</Link>
              </li>
              <li>
                <Link className='dropdown-item' to="/businessUserManager">Manage Business Users</Link>
              </li>
              <li>
                <Link className='dropdown-item' to="/privateUserManager">Manage Private Users</Link>
              </li>
              <li>
                <Link className='dropdown-item' to="/bookingManager" onClick={handleMenuClose}>Manage Bookings</Link>
              </li>
              <li>
                <Link className='dropdown-item' to="/categoryManager">Category Manager</Link>
              </li>
              {isSuperAdmin() && (
                <li>
                  <Link className='dropdown-item' to="/adminManager">Admin Manager</Link>
                </li>
              )}
              <li>
                <Link className='dropdown-item' to="/adminSettings" onClick={handleMenuClose}>Settings</Link>
              </li>
              <li>
                <Link className='dropdown-item' to="/managerCalendarView">Manager Calendar View</Link>
              </li>
              <li>
                <button className='dropdown-item' onClick={() => { onLogout(); handleMenuClose(); }}>Logout</button>
              </li>
            </ul>
          </div>
          <div className='hamburger-menu mobile-menu'>
            <button onClick={() => setMenuOpen(!menuOpen)}>
              <FontAwesomeIcon className='admin-mobile-menu' icon={faBars} />
            </button>
            <ul className={`dropdown-menu ${menuOpen ? 'show' : ''}`}>
              <li>
                <Link className='dropdown-item' to="/manager" onClick={handleMenuClose}>Dashboard</Link>
              </li>
              <li>
                <Link className='dropdown-item' to="/newPackageManager" onClick={handleMenuClose}>Package Manager</Link>
              </li>
              <li>
                <Link className='dropdown-item' to="/businessUserManager" onClick={handleMenuClose}>Manage Business Users</Link>
              </li>
              <li>
                <Link className='dropdown-item' to="/privateUserManager" onClick={handleMenuClose}>Manage Private Users</Link>
              </li>
              <li>
                <Link className='dropdown-item' to="/bookingManager" onClick={handleMenuClose}>Manage Bookings</Link>
              </li>
              <li>
                <Link className='dropdown-item' to="/categoryManager" onClick={handleMenuClose}>Category Manager</Link>
              </li>
              {isSuperAdmin() && (
                <li>
                  <Link className='dropdown-item' to="/adminManager" onClick={handleMenuClose}>Admin Manager</Link>
                </li>
              )}
              <li>
                <Link className='dropdown-item' to="/adminSettings" onClick={handleMenuClose}>Settings</Link>
              </li>
              <li>
                <Link className='dropdown-item' to="/managerCalendarView" onClick={handleMenuClose}>Manager Calendar View</Link>
              </li>
              <li>
                <button className='dropdown-item' onClick={() => { onLogout(); handleMenuClose(); }}>Logout</button>
              </li>
            </ul>
          </div>
        </>
      )}
    </header>
  );
};

export default Header;